// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__2yACI","Label":"BuildControl_Label__2m2zC","Less":"BuildControl_Less__3FOZf","More":"BuildControl_More__7-vP8"};